import { render, staticRenderFns } from "./Official_Duration.vue?vue&type=template&id=342de750&scoped=true"
import script from "./Official_Duration.vue?vue&type=script&lang=js"
export * from "./Official_Duration.vue?vue&type=script&lang=js"
import style0 from "./Official_Duration.vue?vue&type=style&index=0&id=342de750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342de750",
  null
  
)

export default component.exports